export default __webpack_public_path__ + "static/gt-ccfc27d34052eec1eb6ecfa9805ae620.svg";